/* eslint require-jsdoc: 0 */
export const LOGIN_START = 'AUTH_LOGIN_START'
export const START_CLONE = 'AUTH_START_CLONE'
export const LOGIN_FINISH_SUCCESS = 'AUTH_LOGIN_FINISH_SUCCESS'
export const LOGIN_FINISH_ERROR = 'AUTH_LOGIN_FINISH_ERROR'
export const USER_INFO_FINISH_SUCCESS = 'AUTH_USER_INFO_FINISH_SUCCESS'
export const USER_INFO_FINISH_ERROR = 'AUTH_USER_INFO_FINISH_ERROR'
export const LOGOUT = 'AUTH_LOGOUT'

export function startLogin(token) {
  return { type: LOGIN_START, data: { token } }
}
export function startClone(token) {
  return { type: START_CLONE, data: { token } }
}
export function logout(licenseId, token) {
  return { type: LOGOUT, data: { licenseId, token } }
}
export function finishLoginSuccess(token) {
  return { type: LOGIN_FINISH_SUCCESS, data: token }
}
export function finishLoginError(error) {
  return { type: LOGIN_FINISH_ERROR, data: error }
}
export function finishGetUserInfoSuccess(userInfo) {
  return { type: USER_INFO_FINISH_SUCCESS, data: userInfo }
}
export function finishGetUserInfoError(error) {
  return { type: USER_INFO_FINISH_ERROR, data: error }
}
